(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auric-product-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__auricChainUpsellInit) return;
    window.__auricChainUpsellInit = true;

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-chain-upsell-form]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[data-chain-btn]');
      var textEl = btn.querySelector('[data-chain-btn-text]');
      var originalText = textEl.textContent;
      var addedText = btn.dataset.addedText || originalText;
      var variantId = form.querySelector('[name="id"]').value;

      btn.disabled = true;
      textEl.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw d; });
          return fetch('/cart.js').then(function (r2) { return r2.json(); });
        })
        .then(function (cart) {
          textEl.textContent = addedText;
          // Dispatch the event name the Horizon theme actually listens for,
          // with the full cart as resource so cart icon/drawer update immediately.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'auric-chain-upsell',
              data: { source: 'auric-chain-upsell', itemCount: cart.item_count }
            }
          }));
          setTimeout(function () {
            textEl.textContent = originalText;
            btn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          textEl.textContent = originalText;
          btn.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
